<template>
  <div class="works">
    <work-modal v-if="selectedWork" :selected-work="selectedWork" />
    <div class="wrapper" :class="{ 'wrap-loading': !finishLoading }">
      <div class="title">
        <h2>Please have a look 😊</h2>
        <i>You can click a card for more detailed look</i>
      </div>
      <div v-if="!finishLoading" class="loading">
        <LoadingSpinner :message="timeout ? 'This takes longer than usual...' : 'Please wait'" />
      </div>
      <div v-if="finishLoading" class="grid-list">
        <work-card v-for="work in works" :key="work.id" :work="work" @setSelectedWork="setSelectedWork" />
      </div>
      <div v-else class="grid-list placeholder">
        <!-- Placeholder to reserve space -->
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../firestore";
import WorkCard from "@/components/WorkCard";
import WorkModal from "@/components/WorkModal";
import LoadingSpinner from "@/components/LoadingSpinner";

const worksCollection = db.collection("works");

export default {
  name: "Works",
  components: { WorkCard, WorkModal, LoadingSpinner },
  data: function () {
    return {
      works: [],
      selectedWork: undefined,
      finishLoading: false,
      timeout: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.timeout = true;
    }, 3000);

    // Get works without server-side ordering
    worksCollection.get().then(snapshot => {
      const worksArray = [];
      snapshot.forEach(doc => {
        worksArray.push({ id: doc.id, ...doc.data() });
      });

      // Custom sort: titles starting with year (4 digits) first (desc), then others (asc)
      worksArray.sort((a, b) => {
        const yearRegex = /^(\d{4})/;
        const aMatch = a.title.match(yearRegex);
        const bMatch = b.title.match(yearRegex);

        if (aMatch && bMatch) {
          // Both have years: compare years descending
          return parseInt(bMatch[1]) - parseInt(aMatch[1]);
        } else if (aMatch) {
          // Only a has year: a comes first
          return -1;
        } else if (bMatch) {
          // Only b has year: b comes first
          return 1;
        } else {
          // Neither has year: alphabetical ascending
          return a.title.localeCompare(b.title);
        }
      });

      this.works = worksArray;
      this.finishLoading = true;
      this.timeout = false;
    }).catch(error => {
      console.error("Error loading works collection:", error);
      console.error("Error details:", error.message, error.code);
      this.finishLoading = true;
      this.timeout = false;
      alert("Error loading works: " + error.message);
    });
  },
  methods: {
    setSelectedWork: function (e) {
      this.selectedWork = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.works {
  flex-grow: 1;
  width: 100%;
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrapper {
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
  }

  .title {
    text-align: center;
    margin-bottom: 48px;

    h2 {
      font-family: 'Inter', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      font-size: 32px;
      font-weight: 700;
      color: var(--color07);
      margin: 0 0 8px 0;
    }

    i {
      color: #6B7280;
      font-size: 14px;
      font-style: normal;
    }
  }

  .grid-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;
    width: 100%;

    &.placeholder {
      min-height: 600px;
    }
  }

  .wrap-loading {
    width: 100%;
  }
}

// Tablet: 2 columns
@media (min-width: 768px) {
  .works {
    padding: 40px 0px;

    .wrapper {
      max-width: 90%;
    }

    .grid-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }
  }
}

// Desktop: 3 columns
@media (min-width: 1024px) {
  .works {
    .wrapper {
      max-width: 1200px;
    }

    .grid-list {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
